import { DirectSaleCartActionTypes, DirectSaleCartState } from '../types';
import { IOrderProduct } from '../../types/orderProduct';

const initialState: DirectSaleCartState = {
  items: JSON.parse(localStorage.getItem('directSaleItems') || '[]'),
};

export default function (state = initialState, action: DirectSaleCartActionTypes): DirectSaleCartState {
  switch (action.type) {
    case 'UPSERT_DIRECT_SALE_PRODUCT': {
      let items = state.items;
      if (items.find((item) => item.id === action.payload.productOrder.id)) {
        items = items.map((item) => {
          if (item.id === action.payload.productOrder.id) {
            item.quantity += action.payload.productOrder.quantity;
          }
          return item;
        });
      } else {
        items.push(action.payload.productOrder);
      }
      localStorage.setItem('directSaleItems', JSON.stringify(items));
      return {
        ...state,
        items,
      };
    }
    case 'REMOVE_DIRECT_SALE_PRODUCT': {
      const items = state.items.filter((item) => item.id !== action.payload.productOrderId);

      localStorage.setItem('directSaleItems', JSON.stringify(items));
      return {
        ...state,
        items,
      };
    }

    case 'EMPTY_DIRECT_SALE_CART': {
      const items: IOrderProduct[] = [];
      localStorage.setItem('directSaleItems', JSON.stringify(items));
      return {
        ...state,
        items,
      };
    }

    default:
      return state;
  }
}
